export default [
  { value: 'Admin', name: 'Admin', id: 'Admin' },
  { value: 'Dispatch', name: 'Dispatch', id: 'Dispatch' },
  { value: 'Operations', name: 'Operations', id: 'Operations' },
];
